import { create } from "zustand";
import type { ProductCompanyListVO } from "../api/types/product.js";
import { getProductCompanyList } from "../api/product.js";

interface ProductCompanyState {
  productCompanyList: ProductCompanyListVO[];
  loading: boolean;
  loaded: boolean;
  fetchProductCompanyList: () => Promise<void>;
}

export const useProductCompanyStore = create<ProductCompanyState>((set, get) => ({
  productCompanyList: [],
  loading: false,
  loaded: false,

  fetchProductCompanyList: async () => {
    const { loaded, loading } = get();

    // 如果已加载或正在加载，则不重复请求
    if (loaded || loading) return;

    set({ loading: true });
    try {
      const list = await getProductCompanyList();
      set({
        productCompanyList: list || [],
        loaded: true,
      });
    } catch (error) {
      console.error("加載產品公司列表失敗:", error);
    } finally {
      set({ loading: false });
    }
  },
}));
